(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope', '$location'];

    function errorHandlerInterceptor ($q, $rootScope, $location) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('anrescowebApp.httpError', response);

                if(! response.data.path === '/api/notifications/top'){
                    $rootScope.$emit('closeModal', 'Close modal');
                    $location.path('login');
                }

            }
            return $q.reject(response);
        }
    }
})();
